/*
* author ivanm
*/
define(function (require) {
    "use strict";

    var Marionette = require('marionette');

    return Marionette.ItemView.extend({

        template: require("registration-templates/registrationThankYouView.tmpl"),

        className: 'registration-thank-you-view'
    });
});


